import React from "react";
import mypic from "../assets/images/mypic.jpg";

const About = () => {
  return (
    <div className="row py-lg-5">
      <div className="col-lg-6 col-md-8 mx-auto order-0">
        <h5 className="fw-normal">Hello, my name is</h5>
        <h1 className="fw-normal">VENKATAKRISHNAN</h1>
        <p className="lead text-muted">
          I'm a full-stack developer specialised in frontend and backend
          development for scalable web apps.I have made a variety of Mern Stack
          Applications. Want to know how I may help your project? Check out my
          projects from my GitHub Profile.{" "}
          <span>
            <a
              className="badge bg-light text-dark"
              href=" https://github.com/Krish90s"
              rel="noreferrer"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              {" "}
              <i className="bi bi-github" /> Profile
            </a>
          </span>
        </p>
        <a
          className="btn btn-dark btn-sm"
          href="https://drive.google.com/file/d/162siLHvds3QL5fLK66pTB3-tSaEGx2dn/view?usp=sharing"
          rel="noreferrer"
          target="_blank"
        >
          My Resume
        </a>
      </div>
      <div className="col-lg-6 col-md-8 mx-auto order-1">
        <div className="text-center mx-auto my-3">
          <img
            src={mypic}
            className="profile-image mb-3 mb-lg-0 ms-md-0 mx-auto w-50"
            alt="..."
          />
        </div>
      </div>
    </div>
  );
};

export default About;
